import { useState, useEffect, useRef } from 'react';
import { Container, Grid } from '@mui/material';
import '../styles.scss';

export default function Pregunta2({ setRespuesta, cambiarPregunta, sumarPuntos }) {
	const canvasRef2 = useRef(null);
	const containerRef2 = useRef(null);
	const [connections, setConnections] = useState([
		{ from: '', to: '' },
		{ from: '', to: '' },
		{ from: '', to: '' },
	]);
	const [btn1, setBtn1] = useState('');
	const [btn2, setBtn2] = useState('');
	const [btn3, setBtn3] = useState('');
	const [btn4, setBtn4] = useState('');
	const [concept1, setConcept1] = useState('');
	const [concept2, setConcept2] = useState('');
	const [concept3, setConcept3] = useState('');
	const [concept4, setConcept4] = useState('');

	const [selectedPalabra, setSelectedPalabra] = useState(null);
	const [selectedPal, setSelectedPal] = useState(null);

	const respuestas = [
		{ from: 'Hechos', to: 'Demuestra el impacto de los comportamientos en el desempeño.' },
		{ from: 'Acompañamiento', to: 'Identifica áreas de mejora y brinda soporte al desarrollo.' },
		{ from: 'Seguimiento', to: 'Genera ajustes según resultados observados.' },
	];

	const handleWordClick = (id, word) => {
		let array = connections;
		setSelectedPal(id);
		switch (id) {
			case 1:
				setBtn1('btn1');
				setSelectedPalabra('btn1');
				array[id - 1] = { from: word, to: '' };
				setConnections(array);
				break;
			case 2:
				setBtn2('btn2');
				setSelectedPalabra('btn2');
				array[id - 1] = { from: word, to: '' };
				setConnections(array);
				break;
			case 3:
				setBtn3('btn3');
				setSelectedPalabra('btn3');
				array[id - 1] = { from: word, to: '' };
				setConnections(array);
				break;

			default:
				break;
		}
	};
	const handleConceptClick = (id, word) => {
		let array = connections;

		switch (id) {
			case 4:
				setConcept1(selectedPalabra);
				array[selectedPal - 1] = { from: array[selectedPal - 1][`from`], to: word };
				setConnections(array);
				break;
			case 5:
				setConcept2(selectedPalabra);
				array[selectedPal - 1] = { from: array[selectedPal - 1][`from`], to: word };
				setConnections(array);
				break;
			case 6:
				setConcept3(selectedPalabra);
				array[selectedPal - 1] = { from: array[selectedPal - 1][`from`], to: word };
				setConnections(array);
				break;
			default:
				break;
		}

		setSelectedPalabra(null);
		setSelectedPal(null);
	};

	const arraysAreEqual = (arr1, arr2) => {
		if (arr1.length !== arr2.length) return false;
		return arr1.every((obj, index) => JSON.stringify(obj) === JSON.stringify(arr2[index]));
	};

	const siguiente = () => {
		if (arraysAreEqual(connections, respuestas)) {
			setRespuesta('pregunta2', connections);
			console.log('si');

			sumarPuntos(1);
		} else {
			setRespuesta('pregunta2', connections);
			console.log('no');
			sumarPuntos(0);
		}
		cambiarPregunta(3);
	};

	return (
		<>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='pregunta'>
							<div className='num-pregunta'>2.</div>Relaciona cada componente del feedback con su efecto principal desde una gestión remota:
						</div>
					</Grid>
				</Grid>
			</Container>
			<div ref={containerRef2} className='matching-container'>
				<div className='columns'>
					<div className='column words'>
						{/* {words.map((word, index) => (
							<div key={index} id={`${word}`} className='word' onMouseDown={() => (connections.length < 3 ? handleStartConnection(`${word}`) : null)}>
								{word}
							</div>
						))} */}

						<div className={`word ${btn1}`} onClick={() => handleWordClick(1, 'Hechos')}>
							Hechos
						</div>
						<div className={`word ${btn2}`} onClick={() => handleWordClick(2, 'Acompañamiento')}>
							Acompañamiento
						</div>
						<div className={`word ${btn3}`} onClick={() => handleWordClick(3, 'Seguimiento')}>
							Seguimiento
						</div>
					</div>
					<div className='column concepts'>
						{/* {concepts.map((concept, index) => (
							<div key={index} id={`${concept}`} className='concept' onMouseUp={() => (connections.length < 3 ? handleEndConnection(`${concept}`) : null)}>
								{concept}
							</div>
						))} */}
						<div className={`concept ${concept1}`} onClick={() => handleConceptClick(4, 'Identifica áreas de mejora y brinda soporte al desarrollo.')}>
							Identifica áreas de mejora y brinda soporte al desarrollo.
						</div>
						<div className={`concept ${concept2}`} onClick={() => handleConceptClick(5, 'Genera ajustes según resultados observados.')}>
							Genera ajustes según resultados observados.
						</div>
						<div className={`concept ${concept3}`} onClick={() => handleConceptClick(6, 'Demuestra el impacto de los comportamientos en el desempeño.')}>
							Demuestra el impacto de los comportamientos en el desempeño.
						</div>
					</div>
				</div>
			</div>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='siguiente' onClick={() => siguiente()}>
							Siguiente
						</div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}
